import ServiceAccounts from "@affinity/Store/ServiceAccounts";
import { customDispatch } from "@affinity/Store/ServiceBase";
import { createHandlerChainRunner, Handler, HasOnComplete, HasOnError } from "@insite/client-framework/HandlerCreator";
import { get } from "@insite/client-framework/Services/ApiService";

// External properties to call chain
export interface StripeInitialiseParameter {
}

export interface StripeInitialiseResults {
    stripeKey: string;
    errorMessage: string;
    hasError: boolean;
    stripeApi: string;
}

type HandlerType = Handler<StripeInitialiseParameter, StripeInitialiseResults>;

const StateStart: HandlerType = props => {
    (props.dispatch as customDispatch)({
        type: "Affinity/StripePayment/Initialise/Start",
    });
}

const LoadSettings: HandlerType = async props => {
    props.stripeApi = "/api/v1/stripesession";
    const settingsResults = await get<string>(`${props.stripeApi}/settings`);
    if (!settingsResults)
    {
        props.hasError = true;
        props.errorMessage = "Failed to load Stripe Public Key";
    }

    props.stripeKey = settingsResults;
}

const StateComplete: HandlerType = props => {
    (props.dispatch as customDispatch)({
        type: "Affinity/StripePayment/Initialise/Complete",
        stripeKey: props.stripeKey,
    });
}

const chain = [
    StateStart,
    LoadSettings,
    StateComplete,
];

const stripeInitialise = createHandlerChainRunner(chain, "stripeInitialise");
export default stripeInitialise;